<template>
  <GModal class="custom-modal modal--select-category" :noscroll="true">
    <div slot="header">
      <button type="button" class="close hidden-mobile" aria-label="Close">
        <img src="/assets/img/icons/close-modal.svg" @click.prevent="close" />
      </button>

      <div class="hidden-desktop">
        <h2 class="modal-header__heading">
          <img v-if="activeCategoryKey !== -1" src="/assets/img/icons/back-state-mobile.svg" @click.prevent="back" />
          {{ textHeader }}
          <button v-if="activeCategoryKey === -1" type="button" class="close">
            <img src="/assets/img/icons/close-modal.svg" @click.prevent="close" />
          </button>
        </h2>
      </div>
    </div>
    <div slot="body">
      <div class="row hidden-mobile">
        <div class="col-xs-4 toolbar">
          <h4 class="heading">Select Category</h4>
        </div>

        <div class="col-xs-4 toolbar">
          <h4 class="heading">Child Category</h4>
        </div>

        <div class="col-xs-4 toolbar">
          <h4 class="heading">Grand Child Category</h4>
        </div>
      </div>

      <div class="row row-items">
        <div v-show="showCategoriesOfDepartment" class="col-xs-12 col-sm-4 col-items">
          <ul v-if="$SO.size(categoriesOfDepartment)" class="list-item list-category">
            <li
              v-for="(category, key) in categoriesOfDepartment"
              :key="key"
              :class="{ active: key === activeCategoryKey }"
              @click.prevent="selectCategory(key)"
            >
              <a>{{ category.name }}</a>
              <img
                v-if="screen.isDesktop"
                :src="`/assets/img/icons/arrow-left-list-category${key === activeCategoryKey ? '-active' : ''}.svg`"
                class="list-item__img"
              />
              <img v-else :src="`/assets/img/icons/arrow-left-list-category.svg`" class="list-item__img" />
            </li>
          </ul>
        </div>

        <div v-show="showChildCategories" class="col-xs-12 col-sm-4 col-items">
          <ul v-if="$SO.size(childCategories)" class="list-item list-child-category">
            <li
              v-for="(childCategory, keyChild) in childCategories"
              :key="keyChild"
              :class="{ active: keyChild === activeChildCategoryKey }"
              @click.prevent="selectChildCategory(keyChild)"
            >
              <a>{{ childCategory.name }}</a>
              <template v-if="childCategory.sub_categories.length">
                <img
                  v-if="screen.isDesktop"
                  :src="`/assets/img/icons/arrow-left-list-category${
                    keyChild === activeChildCategoryKey ? '-active' : ''
                  }.svg`"
                  class="list-item__img"
                />
                <img v-else :src="`/assets/img/icons/arrow-left-list-category.svg`" class="list-item__img" />
              </template>
            </li>
          </ul>
        </div>

        <div v-show="showGrandChildCategories" class="col-xs-12 col-sm-4 col-items">
          <ul v-if="$SO.size(grandChildCategories)" class="list-item list-grand-child-category">
            <li
              v-for="(grandChildCategory, keyGrandChild) in grandChildCategories"
              :key="keyGrandChild"
              :class="{ active: activeGrandChildCategoryKey === keyGrandChild }"
              @click.prevent="selectGrandChildCategory(keyGrandChild)"
            >
              <a>{{ grandChildCategory.name }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div slot="footer" class="hidden-mobile">
      <div class="row">
        <div class="col-xs-12">
          <a href="" class="btn btn-cancel" @click.prevent="close"> CANCEL </a>

          <a href="" class="btn red btn-select" :class="{ disabled: isDisabledSelect }" @click.prevent="select">
            SELECT
          </a>
        </div>
      </div>
    </div>
  </GModal>
</template>

<script>
export default {
  name: 'modal-select-category',
  data() {
    return {
      activeCategoryKey: -1,
      activeChildCategoryKey: -1,
      activeGrandChildCategoryKey: -1,
    };
  },
  computed: {
    childCategories() {
      if (this.activeCategoryKey > -1) {
        return this.categoriesOfDepartment[this.activeCategoryKey].children;
      }
      return [];
    },
    grandChildCategories() {
      if (this.activeChildCategoryKey > -1) {
        return this.childCategories[this.activeChildCategoryKey].sub_categories;
      }
      return [];
    },
    categoriesOfDepartment() {
      return this.$store.state.header.categoriesOfDepartment;
    },
    isDisabledSelect() {
      if (
        this.$SO.size(this.childCategories) &&
        this.activeChildCategoryKey > -1 &&
        this.$SO.size(this.childCategories[this.activeChildCategoryKey].sub_categories) === 0
      ) {
        return false;
      }
      return this.activeGrandChildCategoryKey > -1 ? false : true;
    },
    savedSelectedCategory() {
      return this.$store.state.addProduct.savedSelectedCategory;
    },
    screen() {
      return this.$store.state.screen;
    },
    showCategoriesOfDepartment() {
      if (!this.screen.isDesktop) {
        return this.activeCategoryKey === -1;
      }
      return true;
    },
    showChildCategories() {
      if (!this.screen.isDesktop) {
        return (
          this.activeCategoryKey > -1 && this.activeChildCategoryKey === -1 && this.activeGrandChildCategoryKey === -1
        );
      }
      return true;
    },
    showGrandChildCategories() {
      if (!this.screen.isDesktop) {
        return (
          this.activeCategoryKey > -1 && this.activeChildCategoryKey > -1 && this.activeGrandChildCategoryKey === -1
        );
      }
      return true;
    },
    textHeader() {
      if (this.activeCategoryKey === -1) {
        return 'Select Category';
      } else if (
        this.activeCategoryKey > -1 &&
        this.activeChildCategoryKey === -1 &&
        this.activeGrandChildCategoryKey === -1
      ) {
        return 'Select Child Category';
      } else if (
        this.activeCategoryKey > -1 &&
        this.activeChildCategoryKey > -1 &&
        this.activeGrandChildCategoryKey === -1
      ) {
        return 'Select Grand Child Category';
      }
      return '';
    },
  },
  watch: {
    activeChildCategoryKey() {
      if (!this.screen.isDesktop) {
        if (
          this.$SO.size(this.childCategories) &&
          this.activeChildCategoryKey > -1 &&
          this.$SO.size(this.childCategories[this.activeChildCategoryKey].sub_categories) === 0
        ) {
          this.select();
        }
      }
    },
  },
  created() {
    if (this.screen.isDesktop) {
      this.filledSelectedMenu();
    }
  },
  beforeDestroy() {
    this.reset();
  },
  methods: {
    back() {
      if (
        this.activeCategoryKey > -1 &&
        this.activeChildCategoryKey === -1 &&
        this.activeGrandChildCategoryKey === -1
      ) {
        this.activeCategoryKey = -1;
      } else if (
        this.activeCategoryKey > -1 &&
        this.activeChildCategoryKey > -1 &&
        this.activeGrandChildCategoryKey === -1
      ) {
        this.activeChildCategoryKey = -1;
      }
    },
    close() {
      this.$store.commit('toggleModalGlobalState', {
        modalName: 'selectCategory',
      });
    },
    select() {
      const categories = [];
      const category = this.categoriesOfDepartment[this.activeCategoryKey];
      const childCategory = this.childCategories[this.activeChildCategoryKey];
      const grandChildCategory = this.grandChildCategories[this.activeGrandChildCategoryKey];

      categories.push(category);

      categories.push(childCategory);

      if (this.$SO.size(grandChildCategory)) {
        categories.push(grandChildCategory);
      }

      this.$store.commit('addProduct/setCategories', categories);
      this.setSelectedMenuCategory();
      if (!this.screen.isDesktop) {
        this.activeGrandChildCategoryKey = -1;
      }
      this.close();
    },
    selectCategory(key) {
      if (this.activeChildCategoryKey > -1) {
        this.activeChildCategoryKey = -1;
      }

      if (this.activeGrandChildCategoryKey > -1) {
        this.activeGrandChildCategoryKey = -1;
      }
      this.activeCategoryKey = key;
    },
    selectChildCategory(key) {
      if (this.activeGrandChildCategoryKey > -1) {
        this.activeGrandChildCategoryKey = -1;
      }
      this.activeChildCategoryKey = key;
    },
    selectGrandChildCategory(key) {
      if (!this.screen.isDesktop) {
        this.activeGrandChildCategoryKey = key;
        this.select();
      } else {
        this.activeGrandChildCategoryKey = key;
      }
    },
    reset() {
      this.activeCategoryKey = -1;
      this.activeChildCategoryKey = -1;
      this.activeGrandChildCategoryKey = -1;
    },
    setSelectedMenuCategory() {
      this.$store.commit('addProduct/setSavedSelectedCategory', {
        activeCategoryKey: this.activeCategoryKey,
        activeChildCategoryKey: this.activeChildCategoryKey,
        activeGrandChildCategoryKey: !this.screen.isDesktop ? -1 : this.activeGrandChildCategoryKey,
      });
    },
    filledSelectedMenu() {
      if (this.$SO.size(this.savedSelectedCategory)) {
        this.activeCategoryKey = this.savedSelectedCategory.activeCategoryKey;
        this.activeChildCategoryKey = this.savedSelectedCategory.activeChildCategoryKey;
        this.activeGrandChildCategoryKey = this.savedSelectedCategory.activeGrandChildCategoryKey;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal--select-category ::v-deep {
  .btn {
    width: 137px;
    height: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font: 12px/17px 'lato-bold', sans-serif;
    letter-spacing: 1.85px;
    border-radius: 4px;
  }

  .btn-cancel {
    color: #231f20;
    background-color: #ffffff;
    border: 1px solid #231f20;
    margin-right: 8px;
  }

  .btn-select {
    &.disabled {
      background-color: #e5e5e5;
      border: none;
    }
  }

  .col-items {
    background-color: #ffffff;
  }

  .heading {
    font: 11px/18px 'lato-bold', sans-serif;
    letter-spacing: 1px;
    color: #231f20;
    text-transform: uppercase;
  }

  .list-item {
    margin: 0 0 0 -16px;
    height: 396px;
    overflow: auto;
    > li {
      cursor: pointer;
      border-bottom: 1px solid #e5e5e5;
      position: relative;
      padding: 16px 16px 20px 16px;
      &:last-child {
        border-bottom: none;
      }
      &.active,
      &:hover {
        background-color: #fff3f3;
        > a {
          color: #b22254;
          font-family: 'lato-bold', sans-serif;
        }
      }
      > a {
        font: 13px/16px 'lato-regular', sans-serif;
        text-transform: capitalize;
        color: #231f20;
      }
    }
  }

  .list-item__img {
    position: absolute;
    right: 24px;
    top: 20px;
    z-index: 9;
  }

  .modal-dialog {
    width: 683px;
    height: 514px;
    border-radius: 4px;
    box-shadow: 1px 2px 14px 0px rgba(#231f20, 0.24);
  }

  .modal-body {
    padding: 0 16px;
  }

  .modal-footer {
    padding: 16px;
    text-align: right;
    border-top: 1px solid #e5e5e5;
  }

  .modal-header {
    padding: 0;
    .close {
      margin: 0;
      top: 13px;
      right: 16px;
      > img {
        height: 16px;
      }
    }
  }

  .row-items {
    background-color: #f8f8f8;
    .col-items {
      &:last-child {
        .list-item {
          margin-right: -16px;
        }
      }
    }
  }

  .toolbar {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    &:before {
      content: ' ';
      position: absolute;
      right: -20px;
      z-index: 11;
      top: 0px;
      width: 20px;
      height: 50px;
      background-image: url('/assets/img/icons/arrow-left-select-category.svg');
      background-size: cover;
      background-repeat: no-repeat;
    }
    &:last-child {
      &:before {
        display: none;
      }
    }
  }
}

@media (max-width: 991px) {
  .modal--select-category ::v-deep {
    .col-items {
      padding: 0;
    }

    .list-item {
      margin: 0;
      > li {
        &.active,
        &:hover {
          background-color: #ffffff;
          > a {
            color: #231f20;
            font-family: 'lato-regular', sans-serif;
          }
        }
      }
    }

    .modal {
      height: 100%;
      background-color: #ffffff;
    }

    .modal-body {
      position: absolute;
      top: 60px;
      right: 0;
      left: 0;
      bottom: 0;
      z-index: 9999;
      padding: 0;
    }

    .modal-dialog {
      width: 100%;
      height: 100%;
      border-radius: 0;
      margin: 0;
      padding: 0;
    }

    .modal-content {
      border: none;
      height: 100%;
    }

    .modal-footer {
      display: none;
    }

    .modal-header {
      padding: 16px;
      height: 60px;
    }

    .modal-header__heading {
      font: 14px/28px 'lato-bold', sans-serif;
      letter-spacing: 2px;
      margin: 0;
      color: #231f20;
      > img {
        margin-right: 20px;
      }
    }
  }
}
</style>
